/**
 * Whether a path renders outside Hawk's shell: the embedded viewers (Inspect
 * on /eval-set/<id>, Scout on /scan/* except /config), the full-page artifact
 * and report browsers, and the sample permalink. Their body is full-bleed on
 * the surface, where Hawk's own pages put a pane on the ground. Hawk's run
 * pages (/status, /timeline, /config, /sample/…/timeline) are inside the shell.
 */
export function isViewerPath(pathname: string): boolean {
  return /^\/(eval-set\/[^/]+(\/sample\/[^/]+\/(artifacts|reports)(\/.*)?)?\/?|scan\/(?![^/]+\/config\/?$).*|permalink\/.*)$/.test(
    pathname
  );
}
